var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { clone } from '../../../common/extensions';
import { HubApiService } from '../../../services/hub.api.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AddCityModalActions, AddCityModalData } from './add.city.modal.provider';
var AddCityModalComponent = /** @class */ (function (_super) {
    __extends(AddCityModalComponent, _super);
    function AddCityModalComponent(dialogRef, actions, formBuilder, hubApiService, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.formBuilder = formBuilder;
        _this.hubApiService = hubApiService;
        _this.data = Object.assign({}, data);
        _this.allCities = clone(_this.data.locationFeeds);
        _this.searchFormGroup = _this.formBuilder.group({
            'search': [null],
        });
        return _this;
    }
    AddCityModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    AddCityModalComponent.prototype.search = function () {
        var _this = this;
        if (this.searchText) {
            this.data.locationFeeds = this.allCities.filter(function (x) { return x.locationFeed.cityTitle.toLowerCase().indexOf(_this.searchText.toLowerCase()) >= 0; });
        }
        else {
            this.data.locationFeeds = clone(this.allCities);
        }
    };
    AddCityModalComponent.prototype.toggle = function (feed) {
        //feed.isInRegion = !feed.isInRegion;
        var _this = this;
        setTimeout(function () {
            _this.data.locationFeeds.forEach(function (x) {
                if (x.locationFeed.id === feed.locationFeed.id) {
                    x.isInRegion = feed.isInRegion;
                }
            });
            _this.allCities.forEach(function (x) {
                if (x.locationFeed.id === feed.locationFeed.id) {
                    x.isInRegion = feed.isInRegion;
                }
            });
        });
    };
    AddCityModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var cities;
            return __generator(this, function (_a) {
                cities = this.allCities.filter(function (x) { return x.isInRegion; }).map(function (y) { return y.locationFeed.id; });
                console.log(cities);
                this.hubApiService.addCitiesToRegion(this.data.hubName, this.data.regionId, cities).subscribe(function (data) {
                    _this.actions.confirm(event, cities);
                    _this.dialogRef.close();
                });
                return [2 /*return*/];
            });
        });
    };
    return AddCityModalComponent;
}(BaseComponent));
export { AddCityModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/add.city.modal/add.city.modal.component.ts.pre-build-optimizer.js